import { Component, Signal, inject, ChangeDetectionStrategy } from '@angular/core'
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core'
import { StateService } from '../../../services/state.service'
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonTitle,
  IonToolbar,
} from '@ionic/angular'
import { RouterLink } from '@angular/router'

@Component({
  selector: 'app-settings-language',
  templateUrl: './settings-language.component.html',
  styles: `
    ion-radio::part(label) {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IonHeader,
    IonButtons,
    IonToolbar,
    IonBackButton,
    IonTitle,
    IonContent,
    IonList,
    IonRadioGroup,
    IonItem,
    IonRadio,
    RouterLink,
    TranslateDirective,
    TranslatePipe,
  ],
})
export class SettingsLanguageComponent {
  private stateService = inject(StateService)

  readonly currentLanguage: Signal<string | undefined>
  readonly targetGroup: Signal<'pre-existing' | 'gestational' | undefined>

  constructor() {
    this.currentLanguage = this.stateService.currentLanguage
    this.targetGroup = this.stateService.targetGroup
  }
  setLanguage(event: CustomEvent) {
    this.stateService.setCurrentLanguage(event.detail.value)
  }
}
